import React from "react";
import { Link } from "react-router-dom";
import { IconProfile } from "../../../assets/icons";

export const ProfileButton = () => {
  return (
    <Link title="profile" className="button-small button-unstyled spc-m-r-1" style={{fontSize: "1.25rem"}} to="/profile">
      <IconProfile fill="#fff" />
    </Link>
  );
};